import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { navigateToUrl } from 'single-spa';

import { Button, Icon, Input, Listbox } from '@ovpn/ui';
import { TenantSwitcher } from '@ovpn/ui/sidebar';

import {
    getPureTenantUrl,
    getTenant,
    selectIsAWSCustomer,
    selectMultiTenants,
} from '@cloud/shared';
import { searchMatch } from 'ovpn-ui-toolkit';

export function AppTenantSwitcher() {
    const activeTenant = getTenant();
    const tenants = useSelector(selectMultiTenants);
    const hideTenantAddButton = useSelector(selectIsAWSCustomer);

    const [query, setQuery] = useState('');
    const filteredTenants = query ? tenants.filter(tenant => searchMatch(tenant, query)) : tenants;

    const handleChange = useCallback((tenantId: string) => {
        navigateToUrl(getPureTenantUrl(tenantId));
    }, []);

    return (
        <TenantSwitcher
            name={activeTenant}
            domain="openvpn.com"
            title="Switch Cloud ID"
            footer={
                !hideTenantAddButton
                    ? ({ onClick }) => (
                          <Button
                              iconLeft="circle-plus"
                              onClick={() => {
                                  navigateToUrl('/billing/domain-create');
                                  onClick();
                              }}
                          >
                              Add Cloud ID
                          </Button>
                      )
                    : undefined
            }
        >
            {({ onClick }) => (
                <>
                    <Input
                        type="search"
                        iconLeft="search"
                        placeholder="Search"
                        value={query}
                        onChange={e => setQuery(e.target.value)}
                    />
                    <Listbox id="tenant" value={id => id === activeTenant} onChange={handleChange}>
                        {filteredTenants.map(tenant => (
                            <Listbox.Option
                                key={tenant}
                                id={tenant}
                                prefix={<Icon name="cloud" className="tenant-menu-link-icon" />}
                                suffix={({ selected }) =>
                                    selected ? <Icon name="check" /> : undefined
                                }
                                onClick={onClick}
                            >
                                {tenant}
                            </Listbox.Option>
                        ))}
                    </Listbox>
                </>
            )}
        </TenantSwitcher>
    );
}
